import { type ComponentType, lazy } from 'react'
import type { VulcanAppDefinition } from './apps'

const VULCAN_APP_REGISTRY: Record<VulcanAppDefinition['id'], ComponentType> = {
  'cloud-agent-manager': lazy(async () => {
    const module = await import('../../../cloud-agent-manager/src/App')
    return { default: module.App }
  }),
  'workspaces-console': lazy(async () => {
    const module = await import('../../../workspaces-console/src/App')
    return { default: module.App }
  })
}

export function resolveEmbeddedApp(app: VulcanAppDefinition): ComponentType {
  return VULCAN_APP_REGISTRY[app.id]
}
